/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * JA JP resource file
 */
export const labels = {
	title: "EY Canvas Economics",
	status: "ステータス",
	header: "ヘッダ",
	canvas: "Canvas",
	canvasEconomics: "Canvas Economics",
	badRequest: "リクエストの形式が正しくありません。",
	errorBanner: "{0}エラー",
	userProfileDropdown: {
		myProfile: "マイプロファイル",
		signOut: "サインアウト"
	},
	clientCode: "クライアントコード",
	hours: "時間",
	local: "ローカル",
	currency: "通貨",
	rate: "レート",
	forecast: "見込",
	variance: "差異",
	edit: "編集",
	arrowUp: "上向き矢印",
	budget: "予算",
	priorBudget: "前期予算",
	currentBudget: "当期予算",
	summary: "サマリー",
	actual: "実績",
	priorActual: "前期実績",
	currentActual: "当期実績",
	remaining: "残り",
	adjustment: "調整",
	estimate: "見積り",
	isRequired: "{0}が必要です。",
	isPositiveInteger: "{0}が必要でありプラスの整数としてください。",
	isPositiveDecimal: "{0}が必要であり小数第2位のプラス数字としてください。",
	in: "に",
	id: "ID",
	currentYear: "当年度",
	priorYear: "前年度",
	budgetHierarchy: "予算ヒエラルキー",
	executionBudgetHierarchy: "実行予算ヒエラルキー",
	noContentAvailable: "利用可能なコンテンツがありません",
	viewMore: "表示数を増やす",
	budgetExecutionPhase: "{0}内にある全てのオブジェクトに関する予算",
	details: "詳細",
	unallocated: "割当て未了",
	none: "なし",
	thousands: "千",
	millions: "百万",
	lakhs: "十万",
	crores: "千万",
	budgetObjectName: "予算オブジェクト名",
	editActivityCodes: "アクティビティコードの編集",
	save: "保存",
	send: "送信",
	cancel: "キャンセル",
	searchActivityCodes: "アクティビティコードの検索",
	noActivityCodesAvailable: "利用可能なアクティビティコードがありません",
	select: "選択",
	engagementCode: "エンゲージメントコード",
	engagementCodeName: "エンゲージメントコード名",
	activityCode: "アクティビティコード",
	activityCodeDescription: "アクティビティコードの説明",
	searchActivityCodesPlaceholderText: "アクティビティコードの検索",
	addMember: "メンバーの追加",
	closeLabel: "閉じる",
	cancelLabel: "キャンセル",
	seachInputRequired: "必要なインプットの検索",
	nameOrEmail: "名前又はEメールアドレス",
	emailForExternal: "Eメールアドレス",
	noRecord: "結果なし",
	userSearchPlaceholder: "名前又はEメールアドレスを入力しEnterキーを押して結果を確認してください。",
	userSearchPlaceholderForExternal: "Eメールアドレスを入力しEnterキーを押して結果を確認してください。",
	clearAllValues: "全ての入力値をクリアしてください。",
	clear: "クリア",
	inValidEmail: "有効なEメールアドレスを入力してください。",
	invalidClientCode: "無効なクライアントコード",
	railSearchText: "検索",
	open: "開く",
	remove: "削除",
	leave: "リムーブ",
	delete: "削除",
	markAsCompleted: "完了済のマーク付け",
	budgetedHours: "予算時間",
	forecastedHours: "予測時間",
	actualHours: "実績時間",
	ftaVariance: "予実差異",
	ftaVarianceTooltip: "実績差異の予測",
	usedHours: "使用時間",
	etcHours: "ETC時間",
	createProjectCard: "プロジェクトの作成",
	plusClients: "+{0} クライアント",
	plusCodes: "+{0} クライアントコード",
	clientNames: "クライアント名:",
	clientName: "クライアント名:",
	clientNameLabel: "クライアント名",
	clientCodes: "クライアントコード:",
	clientCodeCard: "クライアントコード:",
	financialAnalysis: "財務分析",
	billingExpenses: "請求 & 経費",
	independence: "独立性",
	timeChargedCanvasIndependenceStatus: "EY Canvas及びエンゲージメントコード別のプロジェクト全体の独立性ステータス",
	independenceStatusFromCanvasLabel: "EY Canvasの独立性ステータス",
	independenceRequired: "独立性の確認が必要です",
	validatedCanvas: "EY Canvasにおいて検証済",
	notInvited: "インバイトされていません",
	notApplicable: "N/A",
	incomplete: "未完了",
	other: "その他",
	financialCodesDisplayed: "表示されたフィナンシャルコード",
	independenceStatusChangeReasonLabel: "ステータスの変更",
	independenceStatusChangeReasonDescription: "選択したチームメンバーの完了理由を選択する",
	changeReasonLabel: "理由",
	clarificationLabel: "説明 (任意)",
	characterCount: "{0} （最大200文字）",
	expandAll: "全てを展開する",
	collapseAll: "全てを折りたたむ",
	canvasEngagements: "EY Canvasエンゲージメント名",
	independenceCompleted: "独立性完了",
	engagementName: "エンゲージメント名",
	engagementIndependenceStatus: "エンゲージメントの独立性ステータス別",
	noAssociatedClients: "関連するクライアントがありません",
	noCanvasEngagementsIdentified: "EY Canvasエンゲージメントが識別されません",
	placeholderForSearch: "チームメンバーの検索",
	exportToExcel: "エクセルへ出力",
	all: "すべて",
	updateSelected: "選択済の項目のアップデート",
	updateAll: "全てをアップデート",
	customizeTable: "テーブルのカスタマイズ",
	canvasEngagementName: "EY Canvasエンゲージメント名",
	displayBy: "データの表示単位",
	financialDetails: "財務の詳細",
	actualHoursToDate: "現在までの実績時間",
	byWeekEndingDate: "週末日毎",
	ClickAndDrag: "拡大するため図上をクリック及びドラッグします",
	etc: "完了までの見積時間",
	auditProgress: "EY Canvasの進捗状況",
	tasksAndMilestones: "タスク及びマイルストーン",
	milestonesOverdue: "マイルストーン期限超過",
	milestoneOverdue: "マイルストーン期限超過",
	inProgress: "進行中",
	inReview: "レビュー中",
	Complete: "完了",
	assignments: "割当て",
	assignment: "割当て",
	assignmentsOverdue: "期限超過割当て",
	assignmentOverdue: "期限超過割当て",
	overdue: "期限超過",
	requestOverdue: "期限超過リクエスト",
	requestsOverdue: "期限超過リクエスト",
	total: "合計",
	complete: "完了",
	closed: "クローズ済",
	Unassigned: "割当て未了",
	unassigned: "割当て未了",
	sent: "送信済",
	totalTask: "タスク合計",
	collaboration: "コラボレーション",
	received: "受領済",
	accepted: "承諾済",
	outstanding: "未対応",
	unsentDrafts: "未送信ドラフト",
	draft: "ドラフト",
	drafts: "ドラフト",
	returned: "返却済",
	draftRequests: "ドラフトリクエスト",
	percent: "パーセント",
	preparer: "作成者",
	reviewer: "査閲者",
	NoDataForSelectedOptions: "選択されたオプションに関する情報はありません",
	NoAssignmentDataForSelectedOptions: "エンゲージメントは割当て機能を使用していません",
	NoCollabDataForSelectedOptions: "エンゲージメントではコラボレーション機能は利用されていません。",
	tasks: "タスク",
	totalTasks: "タスク合計",
	requests: "リクエスト",
	requestSent: "送信済リクエスト",
	requestsSent: "送信済リクエスト",
	expandDetails: "詳細を表示",
	onlyProjectAdministratorsCanEdit: "プロジェクト管理者のみ編集権限あり",
	onlyProjectAdministratorsCanDelete: "プロジェクト管理者のみプロジェクト削除権限あり",
	userOptions: "ユーザーオプション",
	userOptionsDropdown: {
		userSettings: "ユーザー設定",
		delegateAccess: "権限委譲の管理",
		privacyNotice: "プライバシー通知",
		signOut: "サインアウト"
	},
	delegateToInstruction: "同僚にアクセスを権限委譲すると、その者はあなたの代理でエンゲージメントコードの検証ができます。この権限委譲によりあなたがアクセス権限を持つ全てのエンゲージメントコードの検証ができます。",
	delegateFromInstruction: "次のユーザーはエンゲージメントコードの検証権限を委譲されました。",
	delegateAccess: "権限委譲の管理",
	addDelegates: "権限委譲を追加",
	addAnother: "新たな権限委譲を追加",
	hideMyDelegate: "権限委譲したメンバーの非表示",
	showMyDelegate: "権限委譲したメンバーの表示",
	duplicateUser: "既に追加済の権限委譲",
	informationRequired: "この情報は必須です。",
	delegateTo: "権限移譲先",
	delegateFrom: "権限移譲元",
	noDelegatesAdded: "追加された権限委譲なし",
	noDelegationReceived: "受領された権限委譲なし",
	removeDelegateMessgae: "この権限委譲を削除しますか？一旦削除すると、あなたの代理で財務エンゲージメントの検証はできなくなります。",
	removeDelegateTitle: "権限委譲の削除",
	delegate: "権限委譲",
	saveAndClose: "保存して閉じる",
	resetZoom: "拡大のリセット",
	exportData: "エクスポートデータ",
	rankCode: "ランクコード",
	userGui: "ユーザーGUI",
	email: "Eメール",
	globalAnsr: "グローバルANSR",
	globalCost: "グローバルコスト",
	globalMargin: "グローバルマージン",
	localAnsr: "ローカルANSR",
	localCost: "ローカルコスト",
	localMargin: "ローカルマージン",
	weekEnding: "週末日",
	welcomeToEconomics: "EY Canvas Economicsへようこそ",
	adminPortal: "管理ポータル",
	home: "ホーム",
	enterFirstNameText: "ユーザーの姓名、またはEメールアドレスを入力し、Enterキーを押して検索してください",
	addBtn: "追加",
	cancelBtn: "キャンセル",
	close: "閉じる",
	selectRole: "ロール",
	upsText: "Ups!",
	sufficientRightsToAccess: "このページにアクセスする権限がありません。",
	detailedInformation: "詳細情報は、データが利用可能になる時期のタイミングの違いにより、提示されたサマリーデータとは異なる場合があります。",
	noResultFound: "検索条件に合致する結果なし",
	loading: "読込中…",
	search: "検索",
	softwareUpdate: "ソフトウェアのアップデート",
	updateLater: "後でアップデート",
	updateNow: "今すぐアップデート",
	updateMsg: "ソフトウェアのアップデートが EY Canvas Economicsで利用可能です。今すぐアップデートを選択し必要なアップデートをダウンロード、インストールしてください。Webページが更新されます。",

	eycanvasEngagements: "EY Canvasエンゲージメント",
	eycanvasEngagement: "EY Canvasエンゲージメント",
	expandView: "表示を展開する",
	noFinancialCodesDisplay: "表示するエンゲージメントコードがありません",
	expand: "展開",
	collapse: "折りたたむ",
	bulkSendIndependenceLabel: "独立性確認を一括送信",
	independenceStatusInviteUserLabel: "内部チームメンバーを「独立性のみ」として追加",
	independenceStatusInviteUserDescription: "以下のチームメンバーの役割を特定してください。このユーザーは '{0}' Canvasエンゲージメントに「独立性のみ」の制限で追加され、独立性を完了するよう通知されます。",
	clickToInviteUser: "独立性確認を送信",
	click: "クリック",
	invitePending: "インバイト保留中",
	engagementRolePlaceholder: "エンゲージメントの役割",
	engagementRoleRequiredErrorMessage: "選択されたチームメンバーのエンゲージメントの役割を選択してください",
	engagementInvitationSuccessToastMessage: "独立性確認を正常に送信しました。",
	engagementInvitationFailureToastMessage: "独立性確認の送信に失敗しました。再試行してください。問題が解決しない場合は、ヘルプデスクに連絡してください。",
	independenceInviteConfirmationMessage: "独立性確認が送信されました。返答を保留中です。",
	engagementRoleRequiredOverAllErrorMessage: "1人以上のユーザーに対してエンゲージメントの役割が選択されていません。独立性確認の送信を進めるために、ドロップダウンからエンゲージメントの役割を選択してください。",
	administrativeContractor: "外部コントラクタ",
};

export const errors = {
	default: "エラーが発生しました。ヘルプデスクに連絡してください。",
	102: "無効なプロジェクト",
	106: "RBAC権限が否認されました。",

	1001: "ユーザーが見つかりません",
	1002: "ユーザーの全ての取得ができませんでした。",
	1003: "ユーザーのGUIは空白にできません。",
	1004: "リクエストは空白にできません。",
	1005: "既に同じGUIのユーザーがいるためユーザーを作成できません。",
	1006: "同じGUIのユーザーが複数います。",
	1007: "ユーザーがアクティブでありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1008: "選択された数字の形式が有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1009: "選択された端数処理の形式が有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1010: "選択された通貨の形式が有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1011: "選択された日付の形式が有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1012: "選択された言語が有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1013: "名の文字数が短すぎ (又は長すぎ)ます。再試行してください。",
	1014: "姓の文字数が短すぎ (又は長すぎ)ます。再試行してください。",
	1015: "選択されたマイナス数字の形式が有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1016: "ユーザーが存在しないため更新できません。",
	1017: "ユーザープリファレンスの取得中にエラーが生じました。APIの呼び出しに失敗しました。",
	1018: "ユーザーの作成中にエラーが生じました。APIの呼び出しに失敗しました。",
	1019: "ユーザープリファレンスの更新中にエラーが生じました。APIの呼び出しに失敗しました。",
	1020: "ユーザはアクティブではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1021: "選択されたテーマの値は有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1022: "選択された通貨の値は有効ではありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	1023: "ユーザーはリクエストされたチームメンバーをプロジェクトから削除する権限を有していません。",
	1024: "権限委譲するユーザーの作成中にエラーが発生しました。API 呼び出しに失敗しました。",
	1025: "権限委譲するユーザーリストは空欄にできません。",
	1026: "ユーザー\の名前は長すぎるか又は短すぎます。",
	1027: "ユーザー\のGUIが無効です。",
	1028: "ユーザー\のEメールアドレスは長すぎるか又は短すぎます。",
	1029: "ユーザーIDは空欄にできません。",
	1030: "ユーザー名は空欄にできません。",
	1031: "ユーザーのEメールアドレスは空欄にできません。",
	1032: "ユーザーはアクセスをリムーブする権限委譲したメンバーではありません。",
	1033: "ユーザーはアクセスをリムーブする権限委譲したメンバーではありません。",
	1034: "ユーザーは既に権限委譲したメンバーです。",
	1035: "ユーザーIDの文字数が適切ではありません。正しいユーザーIDにて再試行してください。",
	1036: "ログインユーザーはリストに含められません。後で再試行してください。",
	1040: "管理者権限がありません。ヘルプデスクに連絡してください。",

	7001: "エンゲージメントのメタデータの呼び出しに失敗しました。",
	7006: "EY Canvasは現在アクセスできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

	8003: "CDS APIからのエンゲージメントの詳細の取得中にエラーが生じました。",
	8006: "EY Canvasは現在アクセスできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
	8004: "エンゲージメントコードが見つかりません。これがMercuryコードである場合は、エンゲージメントタイプが含まれていることを確認してください。再試行してもエラーが続く場合は、ヘルプデスクに連絡してください。",
	8007: "CDS APIからエンゲージメント詳細の取得中にエラーが発生しました。",
	8008: "接続に失敗しました。更新し再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",

	9001: "リクエストは空欄にできません",
	9002: "プロジェクトクライアントコード欄は空欄にできません",
	9003: "プロジェクト名欄は空欄にできません",
	9004: "パーセンテージ欄は空欄にできません",
	9005: "レート欄は空欄にできません",
	9006: "予算には選択されたエンゲージメントが関連付けられていません。",
	9007: "エンゲージメント固有の識別子は空欄にできません",
	9008: "エンゲージメントクライアント名は空欄にできません",
	9009: "エンゲージメント説明は空欄にできません",
	9010: "エンゲージメントクライアント固有の識別子は空欄にできません",
	9011: "関連するエンゲージメントシステムは空欄にできません",
	9012: "関連するエンゲージメント固有の識別子は空欄にできません",
	9013: "関連するエンゲージメント名は空欄にできません",
	9014: "関連するエンゲージメントクライアント固有の識別子は空欄にできません",
	9015: "関連するエンゲージメントクライアント名は空欄にできません",
	9016: "追加された関連するエンゲージメントは空欄にできません",
	9017: "1つ以上のEY Canvasエンゲージメントが無効です。",
	9018: "1つ以上の関連するエンゲージメントコードが無効です。",
	9019: "プロジェクトのパーセンテージはゼロより大きくする必要があります。",
	9020: "プロジェクトのパーセンテージは小数点第2位までの表示とする必要があります。",
	9021: "プロジェクトのレートはゼロより大きくする必要があります。",
	9022: "プロジェクトIDが無効です。",
	9023: "財務分析の呼び出しの取得に失敗しました。",
	9024: "プロジェクトの詳細が見つかりません。",
	9025: "ヘッダー求の取得に失敗しました。",
	9026: "検索条件に合致する結果なし",
	9027: "無効な集計タイプ",
	9028: "現在のユーザーはプロジェクトへアクセスできません。",
	9029: "プロジェクトの請求に関する詳細が見つかりません。",
	9030: "プロジェクトファイナンシャルフィルターが見つかりません。",
	9031: "ユーザー名が長すぎるか又は短すぎます。",
	9032: "ユーザーGUIが無効です。",
	9033: "ユーザーのEメールアドレスが長すぎるか又は短すぎます。",
	9034: "プロジェクト管理者になるには少なくとも1人以上のチームメンバーが必要です。",
	9035: "このプロジェクトの最後のアクティブプロジェクト管理者ユーザーです。プロジェクトを削除するとランディングページからリムーブできます。プロジェクトが削除できない場合は、ヘルプデスクに連絡してください。",
	9036: "1つ以上のEY Canvas エンゲージメントを削除してください。エンゲージメント数が{0}を超えています。",
	9037: "{0}件を超過したため、何人かのチームメンバーをリムーブしてください。",
	9038: "{0}件を超過したため、いくつかのエンゲージメントコードをリムーブしてください。",
	9039: "プロジェクトユーザー数は1名以上とする必要があります。",
	9040: "未検証のフィナンシャルコードは、nullまたは空の文字列にすることはできず、その長さは50文字を超えることはできません。",
	9041: "プロジェクトIDは空欄にできません。",
	9042: "削除を完了できません。再試行し、エラーが続く場合は、ヘルプデスクに連絡してください。",
	9043: "現在のユーザーはプロジェクト編集権限がありません。",
	9044: "プロジェクトファイナンシャル詳細の呼び出しに失敗しました。",
	9045: "プロジェクトステータスが無効です。",
	9046: "プロジェクトユーザーステータスが無効です。",
	9047: "無効なプロジェクトユーザーロールです。",
	9048: "プロジェクト名は500文字以内にしてください。",
	9049: "プロジェクトユーザーの名は空にできません。",
	9050: "プロジェクトユーザーの姓は空にできません。",
	9051: "プロジェクトユーザーGUIは空にできません。",
	9052: "プロジェクトユーザーのEメールは空にできません。",
	9053: "プロジェクトユーザ管理フラグは空にできません。",
	9054: "特権アカウントはプロジェクトユーザーとして追加できません。",
	9055: "プロジェクト経費フィルターが見つかりません。",
	9056: "プロジェクト独立性パッチのリクエスト本文を空白にすることはできません。",
	9058: "エンゲージメントコードは無効です。",
	9063: "独立性完了に根拠が無効な値があります。",
	9064: "独立性完了タイプに無効な値があります。",
	9065: "プロジェクト経費フィルターが見つかりません。",
	9066: "このプロジェクトにリンクされているエンゲージメントIDの数が許可されている最大数を超えています。",
	9067: "無効なパッチ操作。",
	9068: "ステータスが他のユーザーにより既に更新されています。ページを更新すると最新のステータスが表示されます。",
	9069: "独立性パッチAPIが失敗しました。",
	9070: "Canvasエンゲージメントに関連付けられたエンゲージメントコードが重複しています。",
	9071: "Canvasエンゲージメントにプライマリーコードとして関連付けを行えるエンゲージメントコードは１つだけです",
	9072: "Canvasエンゲージメントに関連付けられたプライマリーエンゲージメントコードが無効です。",
	9073: "重複する未検証のエンゲージメントコードがあります。",
	9074: "ユーザーが重複しています。",
	9075: "ユーザーのEメールアドレスが無効です。",
	9076: "エンゲージメントユーザー作成のリクエスト本文を空白にすることはできません。",
	9077: "エンゲージメントユーザー作成のリクエストに重複するユーザーが含まれています。",
	9078: "エンゲージメントユーザーロールが無効です。",
	9079: "無効なCanvasエンゲージメント。",
	9080: "エンゲージメントがプロジェクトにマッピングされていません。",
	9081: "エンゲージメントユーザーの作成リクエストが失敗しました。",
	9082: "操作が行われないためセッションがタイムアウトしました。ページを更新して再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",

	/*Admin error codes*/
	14001: "ユーザーが見つかりません",
	14002: "管理ユーザーの呼び出しに失敗しました",
	14003: "見つかった管理ユーザーはアクティブではありません",
	14004: "管理ユーザーの作成に失敗しました",
	14005: "姓名の名の文字数が短すぎるか長すぎます。再試行してください。",
	14006: "姓名の姓の文字数が短すぎるか長すぎます。再試行してください。",
	14007: "管理者ロールIDが有効ではありません",
	14008: "選択されたユーザーは既に管理者となっています。確認してください。",
	14009: "管理ユーザーの検索呼び出しに失敗しました",
	14010: "ユーザーGUIは空欄にできません",
	14011: "ユーザーGUIはゼロより大きい必要があります",
	14012: "ユーザーIDが有効ではありません。再試行してください。",
	14013: "Eメールアドレスが有効ではありません。再試行してください。",
	14014: "ログインユーザーは管理者ユーザーと同じではありません",
	14015: "管理プロジェクト検索呼び出しに失敗しました",
	14016: "管理ユーザーは存在しますがアクティブではありません",
	14017: "管理者は特権ユーザーアカウントのみになります。",
	14018: "管理者ロールIDは空にできません。",
	14019: "ログインしたユーザーはシステム管理者ではありません。",
	14020: "要求者の特権アカウントは無効です。",
	14021: "管理者は特権ユーザーアカウントのみになります。",
	14023: "既存の管理者ロールの削除中にエラーが発生しました。",
	14024: "更新された管理者ロールの追加中にエラーが発生しました。",
	14025: "管理者ユーザーIDは空にできません。",

	/*PAANS error codes*/
	15001: "現在EYポリシーの作成、承認、通知サービスは利用できません。関連するすべてのポリシーが完了したかどうかを確認できません。関連ポリシーのレビューが未了の場合は、ページを更新して再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。"
};

export const roundingOptions = [{
	value: 'none',
	label: "なし"
},
{
	value: 'thousands',
	label: "単位: 千"
},
{
	value: 'millions',
	label: "単位: 百万"
},
{
	value: 'lakhs',
	label: "単位: 十万"
},
{
	value: 'crores',
	label: "単位: 千万"
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: "英語",
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: "フランス語",
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: "スペイン語",
	value: 'es'
},
{
	displayLanguageId: 7,
	label: "ポルトガル語",
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: "日本語",
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: "中国語 (簡体字)",
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: "中国語 (繁体字)",
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: "ヘブライ語",
	value: 'he'
},
{
	displayLanguageId: 12,
	label: "韓国語",
	value: 'ko'
}
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: "numbericStlye1",
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: "numbericStlye3",
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: "numbericStlye7",
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: "numbericStlye2",
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: "グローバル",
	label: "グローバル"
},
{
	value: "ローカル",
	label: "ローカル"
}
];

export const themeOptions = {
	light: "ライト",
	dark: "ダーク"
};

export const currencyOptions = {
	global: "グローバル",
	local: "ローカル"
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: "グローバル"
},
{
	value: 'Local',
	label: "ローカル"
}
];

export const statusValues = [{
	isActive: true,
	label: "アクティブ"
},
{
	isActive: false,
	label: "非アクティブ"
}
];

export const financialOptions = {
	serviceLine: "サービスライン",
	subServiceLine: "サブサービスライン",
	teamMember: "チームメンバー",
	rank: "職階"
};

export const roles = {
	1: "筆頭業務執行社員",
	2: "業務執行社員",
	3: "エグゼクティブディレクター",
	4: "プリンシパル",
	5: "シニアマネージャー",
	6: "マネージャー",
	7: "シニア",
	8: "スタッフ",
	9: "インターン",
	10: "独立審査担当社員",
	11: "他のパートナー",
	12: "GDS - スタッフ",
	13: "アドバイザリー (ITRA、TAS、Human Capital又はその他)",
	14: "Tax",
	15: "エグゼクティブサポートサービス",
	16: "General Counsel",
	17: "監査品質レビューアー",
	21: "内部監査スーパーバイザー",
	22: "内部監査スタッフ",
	23: "規制当局",
	24: "その他 (例: デューディリジェンス レビュー)",
	25: "オフィス",
	26: "エリア",
	27: "業種",
	28: "国籍",
	29: "グローバル",
	30: "GDS - シニア",
	31: "GDS - マネージャー"
};

export const serviceLines = [{
	value: 0,
	label: "全てのサービスライン"
},
{
	value: 1,
	label: "Advisory"
},
{
	value: 2,
	label: "Assurance"
},
{
	value: 3,
	label: "GCO"
},
{
	value: 4,
	label: "TAS"
},
{
	value: 5,
	label: "Tax"
},
{
	value: 6,
	label: "Other"
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: "利用不可"
},
{
	code: 'ASU',
	label: "Assurance"
},
{
	code: 'TAS',
	label: "Strategy and Transactions"
},
{
	code: 'TAX',
	label: "Tax"
},
{
	code: 'ADV',
	label: "Consulting"
},
];

export const userRanks = [{
	id: '11',
	name: "パートナー"
},
{
	id: '12',
	name: "パートナー"
},
{
	id: '13',
	name: "エグゼクティブディレクター"
},
{
	id: '21',
	name: "シニアマネージャー"
},
{
	id: '32',
	name: "マネージャー"
},
{
	id: '36',
	name: "Taxマネージャー"
},
{
	id: '4',
	name: "コントラクター"
},
{
	id: '41',
	name: "シニア3"
},
{
	id: '42',
	name: "シニア"
},
{
	id: '43',
	name: "スタッフ2"
},
{
	id: '44',
	name: "スタッフ"
},
{
	id: '45',
	name: "シニア2"
},
{
	id: '46',
	name: "スタッフ3"
},
{
	id: '49',
	name: "アソシエート"
},
{
	id: '5',
	name: "管理コントラクター"
},
{
	id: '51',
	name: "インターン"
},
{
	id: '52',
	name: "管理者サポート"
},
{
	id: '53',
	name: "インターン (CBS)"
},
{
	id: '55',
	name: "リード管理者"
},
{
	id: '56',
	name: "上級管理者"
},
{
	id: '57',
	name: "中級管理者"
},
{
	id: '58',
	name: "初級管理者"
},
{
	id: '61',
	name: "ディレクター"
},
{
	id: '62',
	name: "アソシエートディレクター"
},
{
	id: '63',
	name: "アシスタントディレクター"
},
{
	id: '64',
	name: "スーパーバイジングアソシエート"
},
{
	id: '65',
	name: "シニアアソシエート"
},
{
	id: '66',
	name: "アソシエート"
},
{
	id: 'Not available',
	name: "利用不可"
}
];

export const financialAnalysis = {
	noResultFound: "選択されたオプションについて結果なし",
	allServiceLines: "全てのサービスライン",
	allSubServiceLines: "全てのサブサービスライン",
	allMembers: "全てのメンバー",
	allAvailable: "全て利用可能",
	allAdded: "全てを追加",
	selectAll: "全てを選択",
	noResult: "結果が見つかりません",
	noneSelected: "何も選択されていません",
	clearAllSeleted: "選択された#のクリア",
	showSelected: "選択したものを表示",
	allRanks: "全ての職階"
};

export const independenceStatus = [
{
	value: 1,
	label: "未完了 - インバイト未了"
},
{
	value: 2,
	label: "未完了 - 進行中"
},
{
	value: 3,
	label: "完了 - その他"
},
{
	value: 4,
	label: "完了 - EY Canvasで検証済"
}
];

export const eycanvasIndependenceStatus = [
{
	value: 1,
	label: "未完了"
},
{
	value: 2,
	label: "除外事項なし"
},
{
	value: 3,
	label: "除外事項あり - 対応未了"
},
{
	value: 4,
	label: "除外事項解決済 - アクセス拒否"
},
{
	value: 5,
	label: "除外事項解決済 - アクセス許可"
},
{
	value: 6,
	label: "該当なし"
},
{
	value: 7,
	label: "リストア済"
},
{
	value: 8,
	label: "上書き"
},
{
	value: 9,
	label: "前回 - 除外事項なし"
},
{
	value: 10,
	label: "前回 - 除外事項あり - 対応未了"
},
{
	value: 11,
	label: "前回 - 除外事項解決済 - アクセス許可"
},
{
	value: 12,
	label: "前回 - 除外事項解消済 - アクセス拒否"
}
];

export const availableUserRoles = [
	{
		value: 1,
		label: "筆頭業務執行社員",
		displayOrder: 9
	},
	{
		value: 2,
		label: "業務執行社員",
		displayOrder: 8
	},
	{
		value: 3,
		label: "エグゼクティブディレクター",
		displayOrder: 5
	},
	{
		value: 4,
		label: "プリンシパル",
		displayOrder: 6
	},
	{
		value: 5,
		label: "シニアマネージャー",
		displayOrder: 4
	},
	{
		value: 6,
		label: "マネージャー",
		displayOrder: 3
	},
	{
		value: 7,
		label: "シニア",
		displayOrder: 2
	},
	{
		value: 8,
		label: "スタッフ",
		displayOrder: 1
	},
	{
		value: 10,
		label: "EQR",
		displayOrder: 10
	},
	{
		value: 11,
		label: "その他のパートナー",
		displayOrder: 7
	},
	{
		value: 12,
		label: "GDS - スタッフ",
		displayOrder: 13
	},
	{
		value: 16,
		label: "法務",
		displayOrder: 12
	},
	{
		value: 17,
		label: "AQRレビューアー",
		displayOrder: 11
	},
	{
		value: 30,
		label: "GDS - シニア",
		displayOrder: 14
	},
	{
		value: 31,
		label: "GDS - マネージャー",
		displayOrder: 15
	}
]

export const employmentStatus = [
{
	value: 'A',
	label: "アクティブ"
},
{
	value: 'D',
	label: "退職"
},
{
	value: 'L',
	label: "休職"
},
{
	value: 'T',
	label: "退職"
},
{
	value: 'P',
	label: "休職"
},
{
	value: 'R',
	label: "退職"
},
{
	value: 'U',
	label: "休職"
},
]

export const independenceStatusDropdown = [
	{
	label: "未完了",
		options: [
			{
		value: 1,
		label: "未完了 - インバイト未了"
	},
	{
		value: 2,
		label: "未完了 - 進行中"
	}
	]
},
{
	label: "完了",
	options: [
		{
		value: 3,
		label: "完了 - その他"
		}
	]
}
];

export const customizedTableOptions = [
{
	id: 2,
	label: "EY Canvas独立性ステータス"
},
{
	id: 3,
	label: "メンバーファーム"
},
{
	id: 4,
	label: "国"
},
{
	id: 5,
	label: "チャージ時間"
},
{
	id: 6,
	label: "独立性ステータス全般"
},
{
	id: 7,
	label: "確認日"
},
{
	id: 8,
	label: "雇用ステータス"
},
{
	id: 9,
	label: "更新者"
},
{
	id: 10,
	label: "更新日"
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: "EY Canvas外で完了 - 除外事項なし",
	isDisplayed: true
},
{
	value: 7,
	label: "EY Canvas外で完了 - 除外事項あり",
	isDisplayed: true
},
{
	value: 8,
	label: "EY Canvas外で完了 - 除外事項解決済み",
	isDisplayed: true
},
{
	value: 2,
	label: "常時カバードパーソン",
	isDisplayed: true
},
{
	value: 3,
	label: "法人を退職済",
	isDisplayed: true
},
{
	value: 4,
	label: "休職",
	isDisplayed: true
},
{
	value: 5,
	label: "退職済",
	isDisplayed: false
},
{
	value: 6,
	label: "その他",
	isDisplayed: false
}
];

export const common = {
	selected: "選択済",
	cancel: "キャンセル",
	checkbox: {
		selectAllOn: "全てを選択",
		selectAllOff: "全ての選択を解除"
	},
	clear: "クリア",
	close: "閉じる",
	nav: {
		projectName: "プロジェクト名"
	},
	pagination: {
		show: "表示",
		iconHover: {
			first: "最初のページ",
			previous: "前のページ",
			next: "次のページ",
			last: "最後のページ"
		}
	},
	search: {
		clear: "検索のクリア",
		buttonTitle: "検索",
		placeholder: "検索",
		noResultsPlaceholder: "結果が見つかりません"
	},
	table: {
		remove: "削除",
		noDataPlaceholder: "利用可能なデータがありません",
		noResultsPlaceholder: "結果が見つかりません"
	},
	toggleSwitch: {
		no: "いいえ",
		yes: "はい"
	},
	wizard: {
		next: "続行",
		back: "戻る",
		finish: "完了"
	},
	unsavedChanges: "未保存の変更",
	unsavedChangesDescription: "続行すると失われる未保存の変更があります。変更を元に戻してもよろしいですか？"
};

export const project = {
	myProjects: "マイプロジェクト",
	priorProjects: "過去のプロジェクト",
	searchForBudgets: "検索",
	emptyContainer: "アクティブな予算がありません。'予算の作成'をクリックし開始してください。",
	noResultsFound: "結果なし",
	create: {
		title: "プロジェクトの作成",
		clientCode: "クライアントコード",
		clientCodeInfo: "対応コードがありません。コードが発行されたシステム (Mercury又はGFIS)上のコードを使用してください。",
		clientName: "クライアント名",
		clientNamePlaceholder: "クライアント名を表示するためにクライアントコードを入力してください。",
		name: "プロジェクト名",
		rate: "デフォルトの時間当りレート",
		rateInfo: "デフォルトの時間当りレートは予算時間の金額の計算に使用します。このレートは報酬請求額を総予想時間で除した値として計算する必要があります。",
		percentage: "予想リアライゼーション率",
		percentageInfo: "予想リアライゼーション率はMercury又はGFIS上でチャージされた時間数の時間価値に適用されます。",
		relateEngagementsInstructionalText: "このプロジェクトに使用される1つ以上のEY Canvasエンゲージメントを選択してください。これらのエンゲージメントの指標は財務データとともに表示されます。現在アクセス可能なエンゲージメントのみ表示されます。",
		selectClientAndWorkspaceInstructionalText: "このプロジェクトに関連するEY Canvasエンゲージメントを識別するためにクライアント及びワークスペースを選択してください。",
		engagementPanelPlaceholder: "提案されたエンゲージメントを表示するためにクライアント及びワークスペースを選択してください。",
		engagementPanelNoResultsFound: "結果なし",
		emptyEngagements: "利用可能なEY Canvasエンゲージメントがありません。開始するためにEY Canvas上で新規エンゲージメントを作成してください。",
		selectClient: "クライアントの選択",
		selectWorkspace: "ワークステップの選択",
		selectEngagements: "エンゲージメントの選択",
		selectedEngagements: "追加されたエンゲージメント",
		selectedEngagementError: "続行するために1つ以上のエンゲージメントを選択",
		searchEngagements: "エンゲージメントの選択",
		searchUsers: "ユーザーの検索",
		engagementLabel: "{0} | ID: {1}",
		addBtn: "追加",
		removeBtn: "削除",
		clientLbl: "クライアント",
		engagementCodeLbl: "エンゲージメントコード",
		engagementTypeCodeLbl: "エンゲージメントタイプ",
		engagementNameLbl: "エンゲージメント名",
		engagementId: "ID",
		addedByLbl: "追加者",
		engagementDescriptionLbl: "エンゲージメントの説明",
		systemLbl: "システム",
		noEngagementsLabel: "エンゲージメントコードをこのプロジェクトに関連付けてください。",
		step4InstTxt: "プロジェクトに関連付けるために1つ以上のエンゲージメントコードを選択してください。",
		relatedEngagementCodesSubtitle: "関連するエンゲージメントコード",
		relatedEngagementCodeLink: "Mercury又はGFIS上のエンゲージメントコードを関連付けてください。対応するコードがありません。",
		unauthorizedModalHeader: "権限のないユーザー",
		unauthorizedText: "関連付けを行う権限がありません",
		allowedUsersText: "このアクションが実行できる個人リストは以下のとおりです。",
		closeBtn: "閉じる",
		validateBtn: "検証する",
		relatedEngagementAddLabel: "Mercury又はGFIS上のエンゲージメントコードを関連付けてください。対応コードなし。",
		todayLbl: "本日",
		NoEmailMessage: "Eメールアドレスの入力なし",
		noEngagementsAdded: "追加されたエンゲージメントなし",
		selectToImport: "ユーザーをこのプロジェクトにインポートするためにEY Canvasエンゲージメントを選択してください。",
		addMember: "ユーザーがEY Canvasエンゲージメントでアクティブでない場合は、{0}を追加してください。",
		addedMembers: "追加されたメンバー",
		employeeName: "メンバー",
		role: "ロール",
		manageTeamInstructionalText: "関連するEY Canvasエンゲージメント上のアクティブなチームメンバーを選択してください。EY Canvasエンゲージメント外の他のチームメンバーを追加するためには下記の説明を参照してください。",
		currentUser: "現在のユーザー",
		canvasEngagements: "EY Canvas エンゲージメント",
		wizardSteps: [
		{
			stepName: "ステップ1",
			stepDescription: "プロジェクトの詳細の入力",
			active: true
		},
		{
			stepName: "ステップ2",
			stepDescription: "EY Canvas エンゲージメントを選択する"
		},
		{
			stepName: "ステップ3",
			stepDescription: "アクセスの管理",
			relatedEngagementCodesSubtitle: "関連するエンゲージメントコード",
			relatedEngagementCodeLink: "Mercury又はGFIS上のエンゲージメントコードを関連付けてください。対応するコードがありません。",
			unauthorizedModalHeader: "権限のないユーザー",
			unauthorizedText: "関連付けを行う権限がありません",
			allowedUsersText: "このアクションが実行できる個人リストは以下のとおりです。",
			close: "閉じる"
		},
		{
			stepName: "ステップ4",
			stepDescription: "Mercury/GFISと接続する"
		},
		{
			stepName: 'Step 5',
			stepDescription: "エンゲージメントコードをEY Canvasエンゲージメントに関連付ける",
			isExit: true
		}
		],
		ratePerHour: "時間当りレート",
		realizationPercentage: "リアライゼーション率"
	},
	stepOne: {
		enterProjectName: "続行するためにプロジェクト名を入力"
	},
	stepTwo: {
		addCanvasEngagements: "プロジェクトにEY Canvas エンゲージメントを追加",
		editCanvasEngagements: "プロジェクトのEY Canvas エンゲージメントを編集",
		selectCanvasEngagements: "アクセス権のあるEY Canvasのエンゲージメントが表示されます。 プロジェクトに含めるEY Canvasエンゲージメントを1つ以上選択します。",
		noCanvasEngagements: " 利用可能なEY Canvasエンゲージメントがありません。次の手順に進み、プロジェクトの設定を続行します。",
		noCanvasEngagementsSelected: "EY Canvas エンゲージメントが選択されていません",
		noSearchResultsFoundLeftRail: "結果が見つかりません",
		clientName: "クライアント",
		workspace: "ワークスペース",
		engagementCode: "エンゲージメントコード",
		canvasEngagementName: "EY Canvas エンゲージメント",
		changes: "変更",
		tooltipMessages: {
			clientName: "クライアント名",
			clientCode: "クライアントコード",
			engagementCode: "エンゲージメントコード",
			engagementDescription: "エンゲージメント名",
			workspaceID: "ワークスペースID",
			workspaceDescription: "ワークスペース名"
		}
	},
	stepThree: {
		editTeamMembers: "プロジェクトのチームメンバーを編集",
		editTeamMembersWhoWillHaveAccess: "プロジェクトにアクセスできるチームメンバーを編集します。関連するEY Canvasエンゲージメントの一員でないチームメンバーを追加するには、右上の検索機能を使用します。プロジェクトオーナーは、プロジェクトを管理できます(例: チームメンバーの追加または削除)。",
		addTeamMembers: "プロジェクトにチームメンバ―を追加する",
		addTeamMembersWhoWillHaveAccess: "プロジェクトにアクセスできるチームメンバーを編集します。関連するEY Canvasエンゲージメントの一員でないチームメンバーを追加するには、右上の検索機能を使用します。プロジェクトオーナーは、プロジェクトを管理できます(例: チームメンバーの追加または削除)。",
		noCanvasEngagementsSelected: "EY Canvas エンゲージメントが選択されていません",
		noSearchResultsFoundLeftRail: "結果が見つかりません",
		addOtherTeamMembers: "接続されたEY Canvasエンゲージメントに参加していない他のチームメンバーを追加する",
		member: "メンバー",
		projectAdministrator: "プロジェクト管理者",
		clickHere: "ここをクリック",
		nameOrEmail: "名前またはメールアドレス",
		addNewMember: "追加",
		firstName: "名",
		lastName: "姓",
		inviteAndClose: "インバイトして閉じる",
		inviteAndAddAnother: "インバイトして別のメンバーを追加",
		clear: "クリア"
	},
	stepFour: {
		engagementCode: "エンゲージメントコード",
		clientName: "クライアント",
		validation: "ステータス",
		independenceOnly: "独立性のみ",
		noEngagementCodes: "プロジェクトにエンゲージメントコードが追加されていません",
		addNewMember: "追加",
		addEngagementManually: "エンゲージメントコードを追加",
		addEngagementCodes: "エンゲージメントコードを追加",
		editEngagementCodes: "エンゲージメントコードの編集",
		validateEngagement: "追加されたすべてのエンゲージメントコードを検証してください。あなたがGFISかMercuryにおいてアクセス権を有するエンゲージメントコードのみが検証可能です。エンゲージメントコードが\独立性のみ\として認識された場合、このエンゲージメントコードに関する詳細情報（例: チームメンバー、チャージ時間）はこのEconomicsプロジェクトの独立性サマリーに含まれますが、財務関連情報には含まれません。",
		informationalMessage: "Mercuryの場合、エンゲージメントコードの前にエンゲージメントタイプを含めます（例：E-12345678）",
		noCanvasEngagements: "EY Canvas エンゲージメントがこのプロジェクトに追加されていません。",
		engagementCodePlaceholder: "エンゲージメントコードを入力",
		validate: "検証",
		engagementCodeRequired: "エンゲージメントコードが必須",
		searchNoResults: "「結果が見つかりません。」"
	},
	stepFive: {
		title: "エンゲージメントコードのEY Canvasエンゲージメントへの関連付け",
		description: "接続された各EY Canvasエンゲージメントに関連付けられたプライマリエンゲージメントコードを以下に示します。追加のエンゲージメントコードをEY Canvasに関連付けるには、以下のドラッグアンドドロップ機能を使用してください。",
		financialCodes: {
			searchButtonTitle: "検索",
			searchButtonPlaceholder: "エンゲージメントコードで検索",
			header: "エンゲージメントコード",
			noRecords: "エンゲージメントコードが識別されていません。",
			canvasEngagements: "EY Canvas エンゲージメント",
			noResults: "結果が見つかりません"
		},
		canvasEngagements: {
			searchButtonTitle: "検索",
			clearButtonTitle: "クリア",
			noResults: "結果が見つかりません",
			searchButtonPlaceholder: "クライアント又はEY Canvas エンゲージメントで検索",
			header: "クライアントおよびエンゲージメント",
			noRecords: "プロジェクトにEY　Canvas　エンゲージメントが関連付けられていません。",
			noEngagementCodes: "関連するエンゲージメントコードはありません。",
			primary: "プライマリー",
			displayUnassociatedEngagements: "エンゲージメントコードが関連付けられていないEY Canvasエンゲージメントを表示する"
		}
	},
	deleteProject: "プロジェクトの削除",
	deleteDescription: "すべてのユーザーに対してこのプロジェクトを削除してよろしいですか？",
	deleteDescText: "このアクションは元に戻せません。",
	delete: "削除",
	cancel: "キャンセル",
	close: "閉じる",
	confirm: "確認",
	leaveProject: "移動",
	leaveDescription: "このプロジェクトを離れてもよろしいですか？チームメンバーの方は引き続き利用可能です。",
	change: "変更",
	changes: "変更"
};

export const users = {
	settings: {
		title: "ユーザー設定",
		firstName: "名",
		lastName: "姓",
		displayLanguage: "表示言語",
		numberFormat: "数字の形式",
		negativeNumberFormat: "マイナス数字の形式",
		currencyFormat: "通貨の形式",
		dateFormat: "日付の形式",
		roundingFormat: "端数処理の形式",
		save: "保存",
		cancel: "キャンセル",
		errorMessageSelect: "値を選択してください。",
		errorMessageInput: "有効な値を入力してください。",
		isRequired: "が必要です。",
		preferences: "選択",
		yourDelegates: "あなたの代理人",
		yourDelegatesDescription: "Mercury又はGFIS上であなたにアクセス権のあるエンゲージメントコードに関する財務データを取扱う権限をあなたが付与したユーザー",
		delegationsFromOthers: "他の者からの代理",
		delegationsFromOthersDescription: "Mercury又はGFIS上でアクセス権のあるエンゲージメントに関する財務データを取扱う権限をあなたに付与したユーザー",
		noUsersIdentified: "ユーザーが識別されませんでした",
		addADelegate: "代理の追加",
		theme: "テーマ",
		preferredCurrency: "選択された通貨",
		status: "ステータス"
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: "クライアントのフィルター",
		filter: "フィルタ",
		searchPlaceholder: "検索",
		searchClearHoverText: "クリア",
		searchHoverText: "検索",
		unvalidated: "無効化",
		noData: "EY Canvasエンゲージメントが関連付けられていません",
		noResults: "結果なし",
		noInformationAvailable: "選択されたオプションに関する情報はありません。",
		independence: "独立性",
		noDataFound: "データが見つかりません。",
	},
	roundingType: "端数処理:",
	roundingFormats: {
		none: "なし",
		thousands: "単位: 千",
		millions: "単位: 百万",
		lakhs: "単位: 十万",
		crores: "単位: 千万"
	},
	updatedDateType: {
		financialDateLabel: "財務データ",
		updatedOn: "更新日",
		canvasDateLabel: "EY Canvas データ"
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: "TER",
			actualTER: "実績TER",
			billed: "請求済",
			actualBilling: "実績請求額",
			totalEngagementRevenue: "総エンゲージメント収入 (報酬 + 費用)",
			forecastedTER: "予測TER"
		},
		margin: {
			margin: "マージン",
			target: "ターゲット"
		},
		globalDeliveryService: {
			gds: "GDS利用",
			globalDeliveryService: "グローバルデリバリーサービス"
		}
	},
	currency: "通貨:",
	globalCurrency: "グローバル",
	localCurrency: "ローカル",
	noDataAvailable: "選択されたフィルターについて利用可能なデータがありません",
	actualHours: "実績時間",
	etc: "ETC",
	ftaVariance: "予実差異",
	completedTasks: "完了したタスク",
	closedAssignments: "クローズ済割当て",
	acceptedRequests: "承諾済リクエスト",
	gDSUsage: "GDS利用状況",
	summaryHeaderPartner: "パートナー",
	summaryHeaderPpedd: "PPEDD",
	summaryHeaderExecutive: "エグゼクティブ",
	financialProgressCard: {
		financialProgress: "財務上の進捗",
		financialDetails: "財務の詳細",
		ansr: "ANSR",
		nsr: "NSR",
		ansrTooltip: "調整後NER(経費を除く正味報酬)",
		nsrTooltip: "Net Standard Revenue (個別正味標準レート 時間)",
		eafTooltip: "エンゲージメント調整要員",
		cost: "コスト",
		hours: "時間",
		expandDetails: "詳細の展開",
		expand: "展開",
		collapse: "折りたたむ",
		collapseDetails: "詳細を折りたたむ",
		margin: "マージン",
		marginPercentage: "マージン",
		rphAcronym: "RPH",
		cphAcronym: "CPH",
		mphAcronym: "MPH",
		eafAcronym: "EAF",
		actual: "実績",
		budgeted: "予算",
		forecasted: "予測",
		ftaVariance: "予実差異",
		ftaVarianceTooltip: "実績差異の予測",
		rph: "時間当りレート",
		cph: "時間当りコスト",
		mph: "時間当りマージン",
		ansrCost: "NSR / Cost",
		serviceLine: "サービスライン",
		subServiceLine: "サブサービスライン",
		teamMember: "チームメンバー",
		totalAnsr: "Total NSR",
		totalCost: "コスト合計",
		totalHours: "時間合計",
		ansrLabelText: "Net standard revenue",
		rank: "職階",
		performanceActuals: "パフォーマンス実績"
	},
	financialAnalysis: {
		show: "表示",
		first: "最初の",
		last: "最後の",
		previous: "前の",
		next: "次の"
	},
	financialFilters: {
		serviceLine: "サービスライン",
		subServiceLine: "サブサービスライン",
		rank: "職階",
		teamMember: "チームメンバー",
		showMore: "詳細",
		clear: "クリア",
		clearAll: "全てをクリア",
		search: "検索",
		noResultsPlaceholder: "結果なし",
		noFiltersAvailable: "フィルターなし",
		yes: "はい",
		no: "いいえ",
		tooltip: "フィルター",
		expenseType: "費用タイプ"
	},
	billingAndExpenses: {
		title: "現在までの実績請求額",
		forecastedTer: "予測TER",
		forecastedTerTooltip: "予測エンゲージメント収益（報酬＋経費）",
		forecastedBilling: "予測請求額",
		collected: "回収済",
		collectedTooltip: "回収済/請求済",
		unCollected: "未回収",
		unCollectedTooltip: "未回収/請求済",
		billed: "請求済（未入金）",
		billedTooltip: "請求済/予測TER",
		billedTotal: "請求済",
		unbilled: "未請求",
		unbilledTooltip: "未請求/予測TER",
		engagementCode: "エンゲージメントコード",
		invoiceDate: "請求書日",
		currency: "通貨",
		invoiceNumber: "請求書番号",
		amount: "金額",
		noInformationPlaceholder: "選択されたオプションについて利用可能な情報なし",
		actualTer: "実績TER",
		actualTerTooltip: "実績総エンゲージメント収入 (報酬 + 費用)",
		actualExpenseToDate: "現在までの実績費用",
		displayBy: "データ表示者",
		expenseType: "費用タイプ",
		teamMember: "チームメンバー",
		totalExpenseToDate: "現在までの総費用",
		expenseTypeColumn: "費用タイプ",
		teamMemberColumn: "チームメンバー",
		globalExpenseAmount: "グローバルエクスペンス金額",
		localExpenseAmount: "ローカルエクスペンス金額",
		billingSummary: "請求サマリー",
		billingStatus: "請求ステータス",
		billingTER: "TER",
		serviceLine: "サービスライン",
		serviceLineColumn: "サービスライン",
		rank: "職階",
		rankColumn: "職階"
	},
	independence: {
		teamMember: "チームメンバー",
		hoursCharged: "チャージ時間",
		independenceStatus: "独立性ステータス全般",
		confirmationDate: "確認日付",
		memberFirm: "メンバーファーム",
		eyCanvasIndependenceStatus: "EY Canvas独立性ステータス",
		employmentStatus: "雇用ステータス",
		country: "国",
		updatedBy: "更新者",
		updatedDate: "更新日",
		selectColumns: "列を選択する",
		confirmationDateBefore: "確認日付より前",
		confirmationDateAfter: "確認日付より後",
		excelsummary: "サマリー",
		excelMercury: "Mercuryのデータ",
		excelCanvas: "Canvasのデータ",
		name: "名称",
		gui: "GUI",
		rank: "職階",
		emailAddress: "Eメールアドレス",
		clarification: "詳細",
		explanation: "説明",
		updatedOn: "更新日",
		client: "クライアント",
		mercuryEngagementCode: "Mercuryエンゲージメントコード",
		canvasEngagement: "Canvasエンゲージメント",
		email: "Eメール",
		reason: "理由",
		engagementRole: "エンゲージメントの役割",
		location: "ロケーション",
		filter: {
        unassociatedFinancialCodes: "関連付けられていないエンゲージメントコード",
		unassociatedLabel: "関連付けられていない",
		filterHeader: "独立性フィルター",
		noFinancialCodeLabel: "エンゲージメントコードが関連付けられていません",
		noEngagementLabel: "EY Canvasエンゲージメントが関連付けられていません",
		expandText: "展開",
		collapseText: "折りたたむ",
		noDataFound: "データが見つかりません"
	}
},
	header: {
		hours: "時間",
		actualHours: "実績",
		forecastedHours: "予算",
		variance: "予実差異",
		other: "その他",
		ppedd: "PPEDD",
		mgrSrMgr: "シニアマネージャー/マネージャー",
		partnerHours: "パートナー時間",
		executiveDirector: "エグゼクティブディレクター",
		seniorManager: "シニアマネージャー",
		manager: "マネージャー",
		senior: "シニア",
		staff: "スタッフ",
		intern: "インターン",
		billed: "請求済:",
		ter: "TER:",
		forecastedTER: "予測TER:",
		margin: "マージン",
		ansr: "ANSR",
		cost: "コスト",
		terSection: "TER",
		billedSection: "請求済",
		forecastedTERSection: "予測",
		forecastedTERSectionForHeader: "予測TER",
		completedTasks: "完了したタスク",
		completedAssignments: "クローズ済の割当て",
		acceptedRequests: "承諾済リクエスト",
		gdsUsage: "GDS利用状況",
		completedTasksTooltip: "完了",
		totalTasksTooltip: "合計",
		completedAssignmentsTooltip: "クローズ済",
		totalAssignmentsTooltip: "合計",
		acceptedRequestsTooltip: "承諾済",
		sentRequestsTooltip: "送信済",
		gdsHoursTooltip: "GDS",
		actualHoursTooltip: "実績時間",
		otherTooltip: "その他",
		otherHeaderTooltip: "その他",
		ppeddTooltip: "PPEDD",
		mgrSrMgrTooltip: "シニアマネージャー/マネージャー",
		partnerHoursTooltip: "パートナー/プリンシパル",
		executiveDirectorTooltip: "エグゼクティブディレクター/ディレクター",
		seniorManagerTooltip: "シニアマネージャー",
		managerTooltip: "マネージャー",
		seniorTooltip: "シニア",
		staffTooltip: "スタッフ",
		internTooltip: "インターン",
		varianceTooltip: "予実差異",
		ansrTooltip: "調整後NER(経費を除く正味報酬)",
		marginTooltip: "マージン = (ANSR - Cost) / ANSR",
		terSectionHover: "実績総エンゲージメント収入 (報酬 + 費用)",
		forecastedTERSectionHover: "予測総エンゲージメント収入 (報酬 + 費用)",
		billedSectionHover: "実績正味請求額",
		gdsUsageHover: "グローバルデリバリーサービスの利用状況"
	}
};

export const exportOptions = {
	buttonText: "エクスポート",
	downloadCSV: "CSVのダウンロード",
	downloadJPEG: "JPEGのダウンロード",
	downloadPDF: "PDFのダウンロード",
	downloadPNG: "PNGのダウンロード",
	downloadSVG: "SVGのダウンロード",
	downloadXLS: "XLSのダウンロード",
	exitFullscreen: "全画面表示の解除",
	viewFullscreen: "全画面表示",
	printChart: "図の印刷"
};

export const adminLabels = {
	adminPortal: "管理",
	usersTab: "ユーザー管理",
	projectsTab: "プロジェクト管理",
	administrators: "管理者の管理"
};

export const projectUserStatus = {
	active: "アクティブ",
	inactive: "非アクティブ"
};

export const projectUserRoles = {
	defaultUser: "デフォルトユーザー",
	projectAdministrator: "プロジェクト管理者"
};

export const projectStatus = {
	active: "アクティブ",
	deleted: "削除済"
};

export const administratorRoles = {
	none: "なし",
	adminReader: "管理者リーダー",
	adminWriter: "管理者ライター",
	superAdmin: "スーパー管理者"
}

export const addUser = {
	firstName: "名",
	lastName: "姓",
	enterFirstNameText: "ユーザーの姓、名、もしくはメールアドレスを入力し、Enterキーを押して検索して下さい",
	selectRole: "キャンセル済",
	userRole: "ユーザーロール",
	clear: "クリア",
	email: "Eメール",
	role: "ロール",
	cancel: "キャンセル",
	addUser: "ユーザーの追加",
	close: "クローズ",
	add: "追加",
	addAdministrator: "管理者の追加",
	error1: "選択されたユーザーは既にプロジェクトの一部となっています。確認してください。",
	error2: "管理者は特権ユーザーアカウントのみになります。"
};

export const adminManageProjects = {
	manageProjects: "プロジェクト管理",
	description: "プロジェクトIDを入力してプロジェクトを検索する",
	projectId: "プロジェクトID",
	search: "検索",
	clearSearch: "クリア",
	enterValidProject: "有効なプロジェクトIDを入力して下さい",
	projectDetails: "プロジェクト詳細",
	enterProjectName: "プロジェクト名の入力",
	projectName: "プロジェクト名",
	projectStatus: "プロジェクトステータス",
	financialCodes: "フィナンシャルコード",
	noFinancialCodes: "このプロジェクトにはフィナンシャルエンゲージメントコードがマッピングされていません",
	engagementCode: "エンゲージメントコード",
	client: "クライアント",
	status: "ステータス",
	validatedBy: "検証者",
	canvasEngagements: "EY Canvas エンゲージメント",
	canvasEngagement: "EY Canvas エンゲージメント",
	noCanvasEngagements: "このプロジェクトにマッピングされているEY Canvas エンゲージメントはありません。",
	member: "メンバー",
	gui: "GUI",
	firstName: "名",
	lastName: "姓",
	emailAddress: "メールアドレス",
	userRole: "ユーザーロール",
	validated: "検証済",
	unvalidated: "未検証",
	enterValidGui: "プロジェクトIDに有効なGUIを入力してください",
	requiredProjectName: "プロジェクト名は空白にできません",
	successToastMessage: "変更は正常に保存されました",
	resetToastMessage: "リセットが完了しました",
	errorToastMessage: "プロジェクト管理者になるには少なくとも1人以上のプロジェクトメンバーが必要です。変更を確認してください。",
	independenceOnly: "独立性のみ",
	yes: "はい",
	no: "いいえ"
};

export const manageAdministrators = {
	title: "管理者の管理",
	firstName: "名",
	lastName: "姓",
	email: "Eメール",
	role: "ロール",
	description: "新しい管理者の追加または既存の管理者の管理",
	noInformationPlaceholder: "選択されたオプションについて利用可能な情報がありません。",
	updateAdminErrorToast: "更新に失敗しました。確認して、後で再試行してください。",
	updateAdminSuccessToast: "変更は正常に保存されました",
};

export const adminManageUsers = {
	title: "ユーザーの管理",
	description: "ユーザーGUIを入力してユーザーを検索する",
	inputLabel: "ユーザーGUI",
	searchButtonLabel: "検索",
	cancelButtonLabel: "クリア",
	errorMessage: "有効なユーザーGUIの入力",
	userDetails: "ユーザーの詳細",
	projects: "プロジェクト",
	delegates: "権限委譲",
	settings: "設定",
	noResultsPlaceholder: "レコードが見つかりません",
	delegatedTo: "権限移譲先:",
	delegatedFrom: "権限移譲元:",
	gui: "GUI",
	firstName: "名",
	lastName: "姓",
	emailAddress: "Eメールアドレス",
	projectName: "プロジェクト名",
	projectId: "プロジェクトID"
};

export const adminCommon = {
	save: "保存",
	reset: "リセット"
}
